import { MapPin, Phone, Mail, MessageCircle, ArrowUpRight } from "lucide-react";

const WHATSAPP = "918142445677";

const Footer = () => {
  const services = [
    { label: "Plumber", href: "#workers" }, { label: "Electrician", href: "#workers" },
    { label: "Carpenter", href: "#workers" }, { label: "Painter", href: "#workers" },
    { label: "House Maid", href: "#workers" }, { label: "AC Repair", href: "#workers" },
    { label: "Cook", href: "#workers" }, { label: "Real Estate", href: "#real-estate" },
    { label: "Marketplace", href: "#marketplace" },
  ];

  return (
    <footer className="bg-indigo text-white" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-14">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 mb-12">
          <div>
            <div className="flex items-center gap-2 mb-3">
              <div className="w-7 h-7 rounded-lg bg-marigold flex items-center justify-center"><span className="text-indigo font-heading font-bold text-sm">J</span></div>
              <span className="font-heading font-semibold text-lg">Junction</span>
            </div>
            <p className="text-white/50 text-xs leading-relaxed mb-4">Hyderabad's hyperlocal platform for workers, real estate, and goods.</p>
            <div className="flex items-center gap-1.5 text-xs text-white/40"><MapPin size={12} className="text-marigold" />Hyderabad, Telangana</div>
          </div>
          <div>
            <h4 className="text-xs font-bold uppercase tracking-widest text-white/60 mb-4">Services</h4>
            <div className="grid grid-cols-2 gap-y-2">
              {services.map(s => <a key={s.label} href={s.href} className="text-xs text-white/40 hover:text-marigold transition-colors">{s.label}</a>)}
            </div>
          </div>
          <div>
            <h4 className="text-xs font-bold uppercase tracking-widest text-white/60 mb-4">Company</h4>
            <div className="space-y-2">
              <a href="#nri-services" className="text-xs text-white/40 hover:text-marigold block">NRI Services</a>
              <a href="/worker-login" className="text-xs text-white/40 hover:text-marigold block">Worker Login</a>
              <a href="#register" className="text-xs text-white/40 hover:text-marigold block">Become a Worker</a>
              <a href="/admin" className="text-xs text-white/40 hover:text-marigold block">Admin</a>
            </div>
          </div>
          <div>
            <h4 className="text-xs font-bold uppercase tracking-widest text-white/60 mb-4">Get in Touch</h4>
            <div className="space-y-3">
              <a href="tel:+918142445677" className="flex items-center gap-2 text-xs text-white/40 hover:text-marigold" data-testid="footer-phone"><Phone size={12} />+91 81424 45677</a>
              <a href={`https://wa.me/${WHATSAPP}?text=${encodeURIComponent("Hi, I'd like to know more about Junction.")}`} target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 text-xs text-white/40 hover:text-green-400" data-testid="footer-whatsapp"><MessageCircle size={12} />WhatsApp Us</a>
              <a href="mailto:hello@junction.app" className="flex items-center gap-2 text-xs text-white/40 hover:text-marigold" data-testid="footer-email"><Mail size={12} />hello@junction.app</a>
            </div>
          </div>
        </div>
        <div className="border-t border-white/10 pt-6 flex flex-col md:flex-row justify-between items-center gap-3">
          <p className="text-xs text-white/25">&copy; {new Date().getFullYear()} Junction. Made for Hyderabad.</p>
          <div className="flex gap-5">
            <a href="#" className="text-xs text-white/25 hover:text-white/50">Privacy</a>
            <a href="#" className="text-xs text-white/25 hover:text-white/50">Terms</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
